import { Anchor, Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";

import { anchorCss } from "./ActionsDropdownAnchorItem.style";

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const ActionsDropdownAnchorItemPropTypes = {
  children: PropTypes.node,
  eventProperties: PropTypes.object,
  itemCss: PropTypes.object,
  onClick: PropTypes.func,
  __cssFor: PropTypes.object,
};

const ActionsDropdownAnchorItem = ({
  children,
  eventProperties,
  onClick,
  itemCss,
  __cssFor = {},
  ...props
}) => {
  return (
    <li css={itemCss}>
      <AnchorWithTrackEvent
        __cssFor={{
          ...__cssFor?.Anchor,
          root: [anchorCss, __cssFor?.Anchor?.root],
        }}
        styleAnchorAsButton={{
          size: Button.sizes.lg,
          flavor: Button.flavors.tertiary,
        }}
        onClick={onClick}
        {...props}
        {...eventProperties}
      >
        {children}
      </AnchorWithTrackEvent>
    </li>
  );
};

ActionsDropdownAnchorItem.propTypes = ActionsDropdownAnchorItemPropTypes;

export default ActionsDropdownAnchorItem;
